import React, { Component, createRef, Suspense } from "react";
import { Version } from "./../ricos-content";
import { addDevToolsClickListener } from "./../wix-rich-content-common";
import { RicosDevToolsLazy, shouldShowDebuggingInfo } from "./../wix-rich-content-common/lib/devTools";
import { getContentSummary } from "./../wix-rich-content-common/lib/ricosContentAnalytics";
import { ContentViewer } from "./ContentViewer";
import { mergeViewerProps } from "./utils";
class RicosViewerNext extends Component {
  constructor(props) {
    super(props);
    this.loadTextSelection = () => {
      const { textSelectionToolbar, isMobile } = this.props;
      const needTextSelectionToolbar = textSelectionToolbar && !isMobile;
      if (needTextSelectionToolbar && !this.state.TextSelectionToolbar) {
        const TextSelectionToolbar = React.lazy(() => import("./TextSelectionToolbar"));
        this.setState({ TextSelectionToolbar });
      }
    };
    this.loadLinkPreviewPopover = () => {
      const { linkPreviewPopoverFetchData, isMobile } = this.props;
      const needLoadLinkPreviewPopover = linkPreviewPopoverFetchData && !isMobile;
      if (needLoadLinkPreviewPopover && !this.state.LinkPreviewPopover) {
        const LinkPreviewPopover = React.lazy(() => import("./LinkPreviewPopover"));
        this.setState({ LinkPreviewPopover });
      }
    };
    this.onMouseOver = () => {
      this.loadTextSelection();
      this.loadLinkPreviewPopover();
    };
    this.getBiCallback = (key) => {
      const { children, _rcProps } = this.props;
      return children?.props.helpers?.[key] || _rcProps?.helpers?.[key];
    };
    this.viewerRef = createRef();
    this.state = {};
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    console.error({ error, errorInfo });
  }
  componentDidMount() {
    const onViewerLoaded = this.getBiCallback("onViewerLoaded");
    const content = this.props.content || this.props._rcProps?.content;
    const { pluginsCount } = content && getContentSummary(content) || {};
    pluginsCount && onViewerLoaded?.({
      isPreview: false,
      version: Version.currentVersion,
      pluginsCount,
      url: document.URL,
      contentId: content?.metadata?.id
    });
    addDevToolsClickListener(
      this.viewerRef.current,
      () => this.setState({ debugInvokedWithMouse: true })
    );
  }
  render() {
    const { seoSettings, linkPreviewPopoverFetchData, mediaSettings, content, debugMode } = this.props;
    const { TextSelectionToolbar, LinkPreviewPopover } = this.state;
    const mergedProps = mergeViewerProps({
      ...this.props,
      viewerProps: {
        seoMode: seoSettings,
        onMouseOver: this.onMouseOver,
        locale: this.props.locale
      }
    });
    try {
      if (this.state.error) {
        this.props.onError?.(this.state.error);
        return null;
      }
      return [
        /* @__PURE__ */ React.createElement(
          ContentViewer,
          {
            ...mergedProps,
            config: mergedProps.config,
            onHover: () => {
            },
            key: "viewer",
            setRef: this.viewerRef,
            fullscreenProps: mediaSettings?.fullscreenProps,
            devTools: this.state.debugInvokedWithMouse || shouldShowDebuggingInfo(debugMode?.includes("all")) ? /* @__PURE__ */ React.createElement(React.Suspense, null, /* @__PURE__ */ React.createElement(
              RicosDevToolsLazy,
              {
                version: Version.currentVersion,
                mode: "viewer",
                contentState: content,
                ricosProps: this.props,
                autoOpen: this.state.debugInvokedWithMouse ?? false
              }
            )) : null
          }
        ),
        TextSelectionToolbar ? /* @__PURE__ */ React.createElement(Suspense, { key: "TextSelectionToolbar", fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
          TextSelectionToolbar,
          {
            onButtonClick: this.getBiCallback("onViewerAction"),
            container: this.viewerRef.current
          }
        )) : null,
        LinkPreviewPopover ? /* @__PURE__ */ React.createElement(Suspense, { key: "LinkPreviewPopover", fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
          LinkPreviewPopover,
          {
            fetchUrlPreviewData: linkPreviewPopoverFetchData,
            container: this.viewerRef.current
          }
        )) : null
      ];
    } catch (e) {
      this.props.onError?.(e);
      return null;
    }
  }
}
RicosViewerNext.displayName = "RicosViewerNext";
RicosViewerNext.defaultProps = {
  onError: (err) => {
    throw err;
  }
};
var RicosViewerNext_default = RicosViewerNext;
export {
  RicosViewerNext_default as default
};
//# sourceMappingURL=RicosViewerNext.js.map
